import {ValueObject} from '@s-ui/domain'

import {AssistantChatContextAggregate} from '../Aggregates/AssistantChatContextAggregate.js'
import {AssistantChatPageTypeValueObject} from '../ValueObjects/AssistantChatPageTypeValueObject.js'

export class UpdateAssistantChatRequest extends ValueObject {
  #chatId
  #text
  #context

  constructor({chatId, text, context}) {
    super()
    this.#chatId = chatId
    this.#text = text
    this.#context = context
  }

  static create({
    chatId,
    text,
    context: {
      page: {type, adId}
    }
  }) {
    return new UpdateAssistantChatRequest({
      chatId,
      text,
      context: AssistantChatContextAggregate.create({
        pageType: AssistantChatPageTypeValueObject.create({type}),
        adId
      })
    })
  }

  get chatId() {
    return this.#chatId
  }

  get text() {
    return this.#text
  }

  get context() {
    return this.#context
  }
}
